import React, { useState, useRef } from 'react';
import TextField from '@material-ui/core/TextField';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import { useForm, Controller } from 'react-hook-form';
import dayjs from 'dayjs';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import FormControl from '@material-ui/core/FormControl';
import DateRangePickerML from '@/components/DateRangePickerML';
import Autocomplete from '@material-ui/core/Autocomplete';
import SearchIcon from '@material-ui/icons/Search';
import ClearIconML from '@/components/ClearIconML/index';
import AutoComplateML from '@/components/AutoComplateML';
import NumberFormat from 'react-number-format';
import ReplayIcon from '@material-ui/icons/Replay';
import {
  Box,
  // FormControl,
  MenuItem,
  Select,
  InputLabel,
} from '@material-ui/core';
import { useSelector } from 'dva';
import { useIntl } from 'umi';
import webStorage from '@/utils/storageManager';
import Button from '@material-ui/core/Button';
import {
  // COUPON_SOURCE_TYPE,
  COUPON_STATUS,
} from '@/constants';
import SearchGroupStyled from './SearchGroupStyled';

const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(
  props,
  ref,
) {
  const { onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      // thousandSeparator
      isNumericString
      // prefix="$"
    />
  );
});

const SearchGroup = (props) => {
  const searchRef = useRef();
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  //优惠券类型
  // const typeList = [
  //   { name: '满减券', value: 'CASH_COUPON' },
  //   { name: '折扣券', value: 'DISCOUNT_COUPON' },
  //   //目前团购券不支持
  //   // { name: '团购券', value: 'GROUP_COUPON' },
  //   { name: '兑换券', value: 'EXCHANGE_COUPON' },
  //   // 满折券
  //   { name: '满折券', value: 'FULL_DISCOUNT_COUPON' },
  // ];
  const { COUPON_TYPE = [] } = webStorage.get('DICTOBJ') || {};
  const typeList = COUPON_TYPE.map((item) => ({
    value: item.dictCode,
    name: item.nameZh,
  }));
  // 优惠券来源

  const COUPON_SOURCE_TYPE = webStorage.get('DICTOBJ')?.COUPON_SOURCE_TYPE;
  //会员等级
  const levels = useSelector((state) => state.memberManagement.levels);
  //优惠券列表
  const couponList = useSelector((state) => state.cpList.cpSearchList);
  //门店列表
  // const storeList = useSelector(
  //   (state) => state.memberManagement.storeList,
  // )?.data;
  //公司列表
  //公司列表
  const companyList = useSelector((state) => state.couponsSetting.companyList);
  //查询参数
  const { setSearchParam } = props;
  const [isReset, setIsReset] = useState(false);
  const [sendReset, setSendReset] = useState(false);
  const today = dayjs().format('YYYY-MM-DD');
  //重置
  const handleReset = () => {
    setIdValue('');
    setCouponValue(null);
    setStoreValue([]);
    setMobileValue('');
    setCompanyValue([]);
    setCouponCodeValue('');
    setIsReset(true);
    setSendReset(true);
    setDefaultStoreValue([]);
    reset({
      mobile: '',
      couponId: '',
      coupon: '',
      couponType: '',
      status: '',
      level: '',
      companies: null,
      stores: null,
      thirdId: '',
      source: '',
      date: {
        startDate: null,
        endDate: null,
      },
      sendDate: {
        startDate: today,
        endDate: today,
      },
    });
    setSearchParam({
      consumeEndTime: null,
      consumeStartTime: null,
      sendStartTime: today,
      sendEndTime: today,
      mobile: '',
      couponId: '',
      coupon: '',
      couponType: '',
      status: '',
      level: '',
      companies: null,
      stores: null,
      thirdId: '',
      source: '',
      pageSize: '10',
      pageNum: '1',
    });
  };

  const {
    handleSubmit,
    control,
    reset,
    setValue,
    watch,
    // register,
  } = useForm({
    defaultValues: {
      companies: null,
      stores: null,
      sendDate: {
        startDate: today,
        endTime: today,
      },
    },
  });
  //单项置空
  //id
  const [idValue, setIdValue] = useState();
  //优惠券
  const [couponValue, setCouponValue] = useState(null);
  //类型
  const watchType = watch('couponType');
  //状态
  const watchStatus = watch('status');
  //等级
  const watchLevel = watch('level');
  //手机号
  const [mobileValue, setMobileValue] = useState();
  //公司
  const [companyValue, setCompanyValue] = useState([]);
  // 门店
  const [storeValue, setStoreValue] = useState([]);
  const [defaultStoreValue, setDefaultStoreValue] = useState([]);
  //来源
  const watchSource = watch('source');
  //第三方券号
  const [couponCodeValue, setCouponCodeValue] = useState();

  // const [couponIdValue, setCouponIdValue] = useState();
  //清除类型
  const handleClearType = () => {
    setValue('couponType', '');
  };
  //清除状态
  const handleClearStatus = () => {
    setValue('status', '');
  };
  //清除等级
  const handleClearLevel = () => {
    setValue('level', '');
  };
  //清除公司
  // const handleClearCompany = () => {
  //   setValue('company', '');
  // };
  //清除来源
  const handleClearSource = () => {
    setValue('source', '');
  };

  //列表的展开与关闭
  const [collapse, setCollapse] = useState(true);
  return (
    <SearchGroupStyled>
      <form
        onSubmit={handleSubmit((values) => {
          const time = dayjs().format('YYYY-MM-DD : HH:mm:ss');
          if (values.coupon) {
            values.couponId = values.coupon;
          }
          delete values.coupon;
          const val = {
            consumeEndTime: values.date?.endDate,
            consumeStartTime: values.date?.startDate,
            sendStartTime: values.sendDate?.startDate,
            sendEndTime: values.sendDate?.endDate,
            ...values,
            stores: storeValue,
            refreshTime: time,
            pageSize: '10',
            pageNum: '1',
          };
          window.NE_DAWN.trigger(searchRef.current, {
            event: '_ec', // 事件名
            params: { ...val }, // 事件公参
          });
          setSearchParam(val);
        })}
      >
        <Box className="search-wrapper">
          <Box className="left">
            <Box className="line">
              <Controller
                render={(rp) => (
                  <TextField
                    name="couponId"
                    control={control}
                    id="basic"
                    variant="standard"
                    className="input"
                    label={formatMessage({ id: 'coupon.data.n01.lbl01' })}
                    value={rp.value ?? idValue}
                    defaultValue={''}
                    onChange={(e) => {
                      setValue('couponId', e.target.value);
                      setIdValue(e.target.value);
                    }}
                    InputProps={{
                      inputComponent: NumberFormatCustom,
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('couponId', '');
                              setIdValue('');
                            }}
                            edge="end"
                          >
                            {idValue ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="couponId"
                control={control}
                id="basic"
                variant="standard"
                className="input"
                label={formatMessage({ id: 'coupon.data.n01.lbl01' })}
                defaultValue={''}
              />
              <Controller
                name="coupon"
                control={control}
                render={() => (
                  <Autocomplete
                    id="clear-on-blur"
                    options={couponList || []}
                    value={couponValue}
                    name="coupon"
                    isOptionEqualToValue={(option, value) => {
                      return option.id === value.id;
                      // console.log('value', value);
                      // console.log('option', option);
                    }}
                    getOptionLabel={(option) => option.title}
                    onChange={(e, newValue, Type) => {
                      console.log('Type', Type);
                      if (Type === 'clear') {
                        setValue('coupon', '');
                        setCouponValue(null);
                      }
                      setValue('coupon', newValue.id);
                      setCouponValue(newValue);
                    }}
                    clearOnBlur
                    renderInput={(param) => (
                      <TextField
                        {...param}
                        label={formatMessage({ id: 'coupon.data.n01.lbl02' })}
                        variant="standard"
                      />
                    )}
                  />
                )}
              ></Controller>
              <FormControl variant="standard" className="channel single-select">
                <InputLabel>
                  {formatMessage({ id: 'coupon.data.n01.rdo03' })}
                </InputLabel>
                <Controller
                  as={
                    <Select className="select">
                      {typeList.map((item) => (
                        <MenuItem
                          key={item.value}
                          value={item.value}
                          name={item.value}
                        >
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  }
                  label={formatMessage({ id: 'coupon.data.n01.rdo03' })}
                  name="couponType"
                  placeholder=""
                  variant="standard"
                  defaultValue={''}
                  control={control}
                />
                <ClearIconML
                  handleClick={handleClearType}
                  clearValue={watchType}
                ></ClearIconML>
              </FormControl>
              <FormControl variant="standard" className="gender single-select">
                <InputLabel>
                  {formatMessage({ id: 'coupon.data.n01.rdo04' })}
                </InputLabel>
                <Controller
                  as={
                    <Select className="select">
                      {COUPON_STATUS.map((item) => (
                        <MenuItem
                          key={item.value}
                          value={item.value}
                          name={item.value}
                        >
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  }
                  label={formatMessage({ id: 'coupon.data.n01.rdo04' })}
                  name="status"
                  variant="standard"
                  control={control}
                  defaultValue={''}
                />
                <ClearIconML
                  handleClick={handleClearStatus}
                  clearValue={watchStatus}
                ></ClearIconML>
              </FormControl>
            </Box>
            <Box className="line" mt={3}>
              <FormControl variant="standard" className="gender single-select">
                <InputLabel>
                  {formatMessage({ id: 'coupon.data.n01.rdo05' })}
                </InputLabel>
                <Controller
                  as={
                    <Select className="select">
                      {levels &&
                        levels.map((item) => (
                          <MenuItem
                            key={item.code}
                            value={item.code}
                            name={item.code}
                          >
                            {item.name}
                          </MenuItem>
                        ))}
                    </Select>
                  }
                  label={formatMessage({ id: 'coupon.data.n01.rdo05' })}
                  name="level"
                  variant="standard"
                  control={control}
                  defaultValue={''}
                />
                <ClearIconML
                  handleClick={handleClearLevel}
                  clearValue={watchLevel}
                ></ClearIconML>
              </FormControl>
              <Controller
                // as={TextField}
                render={(rp) => (
                  <TextField
                    name="mobile"
                    control={control}
                    id="basic"
                    variant="standard"
                    value={rp.value ?? mobileValue}
                    className="input"
                    label={formatMessage({ id: 'coupon.data.n01.lbl06' })}
                    defaultValue=""
                    onChange={(e) => {
                      setValue('mobile', e.target.value);
                      setMobileValue(e.target.value);
                      return rp.value;
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('mobile', '');
                              setMobileValue('');
                            }}
                            edge="end"
                          >
                            {mobileValue ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="mobile"
                control={control}
                // helperText={Boolean(errors.mobile) && '请输入会员手机号'}
                // rules={{ required: true }}
                // error={Boolean(errors.mobile)}
                id="basic"
                variant="standard"
                className="input"
                label={formatMessage({ id: 'coupon.data.n01.lbl06' })}
                defaultValue=""
              />
              <FormControl variant="standard">
                <Controller
                  render={(rp) => (
                    <DateRangePickerML
                      label="发券时间"
                      startText={formatMessage({
                        id: 'coupon.data.n01.rdo07',
                      })}
                      endText={formatMessage({ id: 'coupon.data.n01.rdo08' })}
                      defaultStartDate={today}
                      defaultEndDate={today}
                      rp={rp}
                      setValue={setValue}
                      onChange={() => {
                        // setSearchParam({
                        //   ...searchParam,
                        //   sendStartTime: startDate,
                        //   sendEndTime: endDate,
                        // });
                        setSendReset(false);
                      }}
                      // name="custom-form-submit-name"
                      isResetDefalut={sendReset}
                    />
                  )}
                  name="sendDate"
                  control={control}
                />
              </FormControl>
              <FormControl variant="standard">
                <Controller
                  render={(rp) => (
                    <DateRangePickerML
                      label="核销时间"
                      startText={formatMessage({
                        id: 'coupon.data.n01.rdo09',
                      })}
                      endText={formatMessage({ id: 'coupon.data.n01.rdo10' })}
                      defaultStartDate={null}
                      defaultEndDate={null}
                      rp={rp}
                      setValue={setValue}
                      onChange={() =>
                        // {
                        //  startDate, endDate, reset
                        //  }
                        {
                          setIsReset(false);
                        }
                      }
                      // name="custom-form-submit-name"
                      isReset={isReset}
                    />
                  )}
                  name="date"
                  control={control}
                />
              </FormControl>
            </Box>
            {!collapse && (
              <Box className="line" mt={3}>
                {companyList && (
                  <Controller
                    render={() => (
                      <Autocomplete
                        id="disable-close-on-select"
                        disableCloseOnSelect
                        className="companies"
                        options={companyList}
                        multiple
                        limitTags={1}
                        value={companyValue}
                        name="companies"
                        // isOptionEqualToValue={(option, value) => {
                        //   return option.id === value.id;
                        //   // console.log('value', value);
                        //   // console.log('option', option);
                        // }}
                        getOptionLabel={(option) => option.name}
                        onChange={(e, newValue, Type) => {
                          if (Type === 'clear') {
                            setValue('companies', null);
                            setCompanyValue([]);
                          }
                          const ids = newValue.map((i) => i.id);
                          setValue('companies', ids);
                          setCompanyValue(newValue);
                        }}
                        clearOnBlur
                        renderInput={(param) => (
                          <TextField
                            {...param}
                            label={formatMessage({
                              id: 'coupon.data.n01.chb11',
                            })}
                            variant="standard"
                          />
                        )}
                      />
                    )}
                    label={formatMessage({ id: 'coupon.data.n01.chb11' })}
                    name="companies"
                    variant="standard"
                    control={control}
                    defaultValue={''}
                  />
                )}
                <AutoComplateML
                  label={formatMessage({ id: 'coupon.data.n01.chb12' })}
                  defaultValue={defaultStoreValue}
                  selectedId={storeValue}
                  setSelectedId={setStoreValue}
                />
                {/* {storeList && (
                  <Controller
                    name="stores"
                    control={control}
                    render={() => (
                      <Autocomplete
                        className="companies"
                        id="disable-close-on-select"
                        disableCloseOnSelect
                        multiple
                        limitTags={1}
                        options={storeList}
                        value={storeValue}
                        name="stores"
                        isOptionEqualToValue={(option, value) => {
                          return option.storeNo === value.storeNo;
                        }}
                        getOptionLabel={(option) => option.name}
                        onChange={(e, newValue, Type) => {
                          if (Type === 'clear') {
                            setValue('stores', null);
                            setStoreValue([]);
                          } else {
                            const storeNos = newValue?.map((i) => i.storeNo);
                            setValue('stores', storeNos);
                            setStoreValue(newValue);
                          }
                        }}
                        clearOnBlur
                        renderInput={(param) => (
                          <TextField
                            {...param}
                            label="核销门店"
                            variant="standard"
                          />
                        )}
                      />
                    )}
                  ></Controller>
                )} */}

                <FormControl
                  variant="standard"
                  className="gender single-select"
                >
                  <InputLabel>
                    {formatMessage({ id: 'coupon.data.n01.rdo13' })}
                  </InputLabel>
                  <Controller
                    as={
                      <Select className="select">
                        {COUPON_SOURCE_TYPE &&
                          COUPON_SOURCE_TYPE.map((item) => (
                            <MenuItem
                              key={item.nameEn}
                              value={item.nameEn}
                              name={item.nameEn}
                            >
                              {item.nameZh}
                            </MenuItem>
                          ))}
                      </Select>
                    }
                    label={formatMessage({ id: 'coupon.data.n01.rdo13' })}
                    name="source"
                    variant="standard"
                    control={control}
                    defaultValue={''}
                  />
                  <ClearIconML
                    handleClick={handleClearSource}
                    clearValue={watchSource}
                  ></ClearIconML>
                </FormControl>
                <Controller
                  render={(rp) => (
                    <TextField
                      name="thirdId"
                      control={control}
                      id="basic"
                      variant="standard"
                      className="input"
                      value={rp.value ?? couponCodeValue}
                      onChange={(e) => {
                        setValue('thirdId', e.target.value);
                        setCouponCodeValue(e.target.value);
                      }}
                      label={formatMessage({ id: 'coupon.data.n01.lbl14' })}
                      defaultValue={''}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              className="clear-btn"
                              onClick={() => {
                                setCouponCodeValue('');
                                setValue('thirdId', '');
                              }}
                              edge="end"
                            >
                              {couponCodeValue ? (
                                <ClearIcon className="clear-icon" />
                              ) : (
                                ''
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                  name="thirdId"
                  control={control}
                  id="basic"
                  variant="standard"
                  className="input"
                  label={formatMessage({ id: 'coupon.data.n01.lbl14' })}
                  defaultValue={''}
                />
              </Box>
            )}
          </Box>
          <Box className="button-group">
            <Button
              variant="contained"
              color="secondary"
              className="reset"
              onClick={handleReset}
              startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'comm.action.btn.06' })}
            </Button>

            <Button
              data-log={JSON.stringify({
                oid: 'btn_coupon_center_coupon_data_details_search',
                events: ['_ev'],
                params: {
                  initUrl: window.location.origin + window.location.pathname,
                },
              })}
              ref={searchRef}
              variant="contained"
              type="submit"
              className="search"
              startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'comm.action.btn.01' })}
            </Button>
          </Box>
        </Box>
        <Box mt={2} mb={1} className="toggle">
          <SvgIconML
            name={!collapse ? 'close' : 'open'}
            onClick={() => {
              setCollapse(!collapse);
            }}
          />
        </Box>
      </form>
    </SearchGroupStyled>
  );
};
export default SearchGroup;
